import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { PaymentsService } from 'src/app/services/payments-services/payments.service';

@Component({
  selector: 'app-payments-gateways-breadcrumb-card',
  templateUrl: './payments-gateways-breadcrumb-card.component.html',
  styleUrls: ['./payments-gateways-breadcrumb-card.component.scss']
})
export class PaymentsGatewaysBreadcrumbCardComponent implements OnInit {

  @Input() gateways;
  filterOpened: boolean;
  viewDisposition;

  constructor(private router: Router,
              private userStorageService: UserStorageService,
              private activatedRoute: ActivatedRoute,
              private paymentsService: PaymentsService) {
                this.viewDisposition = 'grid';
              }

  ngOnInit() {
    if (this.userStorageService.getFilterGateways()) {
      this.toggleBreadcrumbFilter();
    }
  }

  public toggleViewDisposition(viewDis) {
    this.viewDisposition = viewDis;
    this.paymentsService.toggleGatewaysDisposition(viewDis);
  }

  public createGateway() {
    this.router.navigate(['../gateway'], { relativeTo: this.activatedRoute.parent });
  }

  public toggleBreadcrumbFilter() {
    this.filterOpened = !this.filterOpened;
  }

  public search(event) {
    this.paymentsService.searchGateways(event.target.value);
  }
}
